import { Card, Typography, Button, Container, Stack, TableContainer, TableHead, TableRow, TableCell, Checkbox, Table, TableBody, Popover, MenuItem, IconButton, Avatar, Dialog, DialogTitle, DialogContent, Grid, TextField, Autocomplete, FormControl, Select, Chip, CardMedia, CardContent } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Iconify from "src/components/iconify";
import '../../Common_css/style.css';
import fb from '../../components/icons/fb.png';
import insta from '../../components/icons/instagram.png';
import website from '../../components/icons/website.png';
import twitter from '../../components/icons/twitter.png';
import { getData } from "src/webService/webService";
import { toast } from "react-toastify";
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import { useNavigate, useParams } from "react-router-dom";
import productThumbnail from '../../components/icons/brand.png';


export default function ViewBrand({ id, sellerResponse, handleViewProduct }) {

    console.log(id, 'iddddddddddd');
    console.log(sellerResponse, 'sellerResponseeeeeeeee');

    const Token = sessionStorage.getItem('Token');
    const [productList, setProductList] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [seletectedProduct, setSeletectedProduct] = useState();
    const [isOpenGallery, setIsOpenGallery] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const [galleryImages, setGalleryImages] = useState([]);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [getAnalysisData, setGetAnalysisData] = useState({});
    const [brandList, setBrandList] = useState([]);
    const navigate = useNavigate();

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };


    const handleOpenModal = () => {
        setOpenModal(true);
    }

    const handleClose = () => {
        setOpenModal(false);
    }


    const getProductById = async (page, brand_id) => {
        const params = {
            page: page,
            per_page: limit,
        }
        try {
            const res1 = await getData(`sellers/brands/${brand_id}/analytics`, null, Token);
            setGetAnalysisData(res1);
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const getBrandById = async (page) => {
        const params = {
            page: page,
            per_page: limit,
        }
        try {

            const res = await getData(`sellers/${id}/brands`, params, Token);
            setBrandList(res?.data);
            setTotalItems(res?.total);
            setTotalPages(res?.last_page);
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }


    useEffect(() => {
        // getProductById(currentPage);
        getBrandById(currentPage);
    }, [limit])

    const openGallery = (index) => {
        setPhotoIndex(index);
        setIsOpenGallery(true);
    };

    const handleProduct = (index) => {
        const selectedItem = productList[index];
        console.log(selectedItem, 'selectedItem');
        setSeletectedProduct(selectedItem);
        setGalleryImages(selectedItem?.galleryFiles);
    };

    const handleGoToDashboard = (e, brand, newValue) => {
        debugger
        getProductById(currentPage, brand?._id)
        navigate(`/admin/sellers/${sellerResponse?._id}/brands/${brand?._id}/products`)
    };

    return (
        <>

            <Helmet>
                <title> View Product</title>
            </Helmet>

            <Container className='p-0'>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                    <Typography variant="h4" className='title-color' gutterBottom>
                        <Iconify className='backIcon pointer' onClick={handleViewProduct} icon="eva:arrow-back-fill" /> View Brands
                    </Typography>
                </Stack>

                <Card className='card-bg' style={{ height: "500px", overflowY: "scroll", width: "100%", background: '#dfecf1', padding: '30px' }}>
                    <div className="sellerCard">
                        <div className="row">
                            <div className="col-lg-2">
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={2}
                                >
                                    {sellerResponse?.profile_picture ? (
                                        <Avatar src={sellerResponse?.profile_picture} style={{ height: '160px', width: '160px' }}></Avatar>
                                    ) : (
                                        <Avatar style={{ height: '160px', width: '160px' }}>
                                            {sellerResponse?.name
                                                ? sellerResponse?.name[0]
                                                : null}
                                        </Avatar>
                                    )}
                                </Stack>
                            </div>
                            <div className="col-lg-6">
                                <div style={{ marginLeft: '22px' }}>
                                    <h1 className="fw-bold" style={{ color: 'brown' }}>{sellerResponse?.name ? sellerResponse?.name : 'Not Available'}</h1>
                                    <p className="blk"><Iconify icon="eva:pin-outline" /> {sellerResponse?.address ? sellerResponse?.address : 'Address Not Available'}, {sellerResponse?.city ? sellerResponse?.city : 'City Not Available'}, {sellerResponse?.country ? sellerResponse?.country : 'Country Not Available'}</p>
                                    <a style={{ textDecoration: 'none' }} href={sellerResponse?.map_location} target="_blank"><p className="pointer fw-bold blk"><Iconify icon="eva:navigation-2-outline" /> Get Directions</p> </a>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div>
                                <h5 className="blk">About Us:</h5>
                                <p className="blk">{sellerResponse?.aboutus ? sellerResponse?.aboutus : 'About Us Not Available'}</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12 d-flex justify-content-end">
                                {sellerResponse?.facebook_link && (
                                    <a href={sellerResponse.facebook_link} target="_blank">
                                        <img width='50%' className="pointer" src={fb} />
                                    </a>
                                )}
                                {sellerResponse?.instagram_link && (
                                    <a href={sellerResponse.instagram_link} target="_blank">
                                        <img width='50%' className="pointer" src={insta} />
                                    </a>
                                )}
                                {sellerResponse?.website_link && (
                                    <a href={sellerResponse.website_link} target="_blank">
                                        <img width='50%' className="pointer" src={website} />
                                    </a>
                                )}
                                {sellerResponse?.twitter_link && (
                                    <a href={sellerResponse.twitter_link} target="_blank">
                                        <img width='50%' className="pointer" src={twitter} />
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <Typography variant="h4" className='title-color' gutterBottom>
                            View Brand List
                        </Typography>

                        {brandList?.length === 0 ? (
                            <Grid container spacing={2} marginTop={0}>
                                <div className="col-12 text-center mt-5">
                                    <div className="d-flex justify-content-center align-items-center">
                                        <img width='30%' src={productThumbnail} />
                                    </div>
                                    <p>No Brands available</p>
                                </div>
                            </Grid>
                        ) : (
                            <Grid container spacing={2} marginTop={0}>
                                {brandList.map((brand, index) => (
                                    <Grid item xs={12} sm={6} md={4} key={brand.id}>
                                        <Card sx={{ height: '100%' }}>
                                            <CardMedia
                                                sx={{ height: 140 }}
                                                image={brand?.thumbnail}
                                                alt={brand.name}
                                            // sx={{ height: 120, objectFit: 'contain', padding: 2 }}
                                            />
                                            <CardContent>
                                                <Typography variant="h6" gutterBottom>{brand.name}</Typography>
                                                {brand?.category_list?.map((categories, index) => (
                                                    <Chip label={categories?.name} variant="outlined" sx={{
                                                        padding: '0px 0px',
                                                        marginBottom: '10px',
                                                        // display:'flex',
                                                        // justifyContent:'center',
                                                        ":hover": {
                                                            backgroundColor: '#d6e2e9',

                                                        }

                                                    }} />
                                                ))}
                                                <Typography variant="body2" sx={{ mb: 2 }}>
                                                    {brand.description}
                                                </Typography>
                                                <Button variant="contained" size="small" fullWidth
                                                    onClick={(e) => handleGoToDashboard(e, brand)}
                                                >
                                                    Go to product View
                                                </Button>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </div>
                    <div className="d-flex flex-wrap justify-content-end m-3">
                        <FormControl variant="outlined" size="small" style={{ width: "7%" }}>
                            <Select
                                labelId="limit-label"
                                id="limit-select"
                                value={limit}
                                onChange={handleLimitChange}
                            >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={30}>30</MenuItem>
                                <MenuItem value={TotalItems}>All</MenuItem>
                            </Select>
                        </FormControl>
                        <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                            <Iconify icon={"grommet-icons:previous"} />
                        </Button>
                        <Button
                            onClick={handleNextPage}
                            disabled={currentPage === totalPages}
                        >
                            <Iconify icon={"grommet-icons:next"} />
                        </Button>
                    </div>
                </Card>
            </Container>
            <Dialog open={openModal} onClose={handleClose} maxWidth="lg" fullWidth>
                <DialogTitle>Product Detail</DialogTitle>
                <DialogContent>
                    <div className="row">
                        <div className="col-lg-5">
                            <img
                                src={seletectedProduct?.thumbnail}
                                alt="thumbnail"
                                style={{
                                    height: "400px",
                                    objectFit: "cover",
                                    cursor: "pointer",
                                    borderRadius: "10px",
                                }}
                            />
                        </div>
                        <div className="col-lg-6">
                            <div>
                                <h3>{seletectedProduct?.name}</h3>
                                <p>{seletectedProduct?.description}</p>
                            </div>
                            <div className="mt-4">
                                <p><strong>Fabric Type:</strong> {seletectedProduct?.fabric_type ? seletectedProduct?.fabric_type : 'Not Available'}</p>
                                <p><strong>Colors:</strong> {seletectedProduct?.colors ? seletectedProduct?.colors : 'Not Available'}</p>
                                <p><strong>Size:</strong> {seletectedProduct?.sizes ? seletectedProduct?.sizes : 'Not Available'}</p>
                            </div>

                            <div className="d-flex align-items-center">
                                {galleryImages?.map((image, index) => (
                                    <div key={index} style={{ position: "relative", margin: "10px" }}>

                                        {/* Image */}
                                        <Avatar
                                            src={image}
                                            sx={{
                                                height: "90px",
                                                width: "60px",
                                                borderRadius: "10%",
                                                cursor: "pointer",
                                            }}
                                            onClick={() => openGallery(index)}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </DialogContent>
            </Dialog>
            {/* Lightbox for Image Preview */}
            {isOpenGallery && galleryImages.length > 0 && (
                <Lightbox
                    mainSrc={`${galleryImages[photoIndex]}`}
                    nextSrc={`${galleryImages[(photoIndex + 1) % galleryImages.length]}`}
                    prevSrc={`${galleryImages[(photoIndex + galleryImages.length - 1) % galleryImages.length]}`}
                    onCloseRequest={() => setIsOpenGallery(false)}
                    onMovePrevRequest={() => setPhotoIndex((photoIndex + galleryImages.length - 1) % galleryImages.length)}
                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % galleryImages.length)}
                />
            )}
        </>
    )
}